<dx-select-box [showClearButton]="!required"
               [dataSource]="accessLevels"
               [isValid]="!required || !!accessLevel"
               [(value)]="accessLevel"
               (valueChange)="accessLevelChange.emit($event)"
               [searchEnabled]="true"
               displayExpr="label"> </dx-select-box>
